import { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { BaseLoader } from '..';
import { prepareDocumentUrl } from '../../misc/requests';
import { errorToast } from '../../store/slices/toaster.slice';

const DocumentDownload = () => {
  const { t: common } = useTranslation('common');

  const { uuid } = useParams();
  const location = useLocation();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getUrl = async () => {
      try {
        setLoading(true);
        const response = await prepareDocumentUrl(location.pathname, uuid);
        document.location.assign(response);
        // document.location.assign(
        //   import.meta.env.VITE_ENV === 'local' ? import.meta.env.VITE_BASE_URL + response : response
        // );
      } catch (_) {
        errorToast(common('errors.documentDownload'), common('errorToastHeading'));
      } finally {
        setLoading(false);
      }
    };

    getUrl();
  }, [common, location.pathname, uuid]);

  return <BaseLoader loading={loading} />;
};

export default DocumentDownload;
